import { useState } from "react";
import { useGlobalStacks } from "@/state/globalStacks";
import { HGRecordUrl } from "@/common/types";
import RecordSheet from "./RecordSheet";
import { useCollection, useIsOwnSpace } from "@/api/hooks";
import { HGStacks } from "@/stack/stacks";
import { RecordsMode } from "@/state/recordsView";
import { Button } from "../button";
import { Plus } from "lucide-react";

function getEmptyRecord(
  collectionIDs: string[],
  stacks: HGStacks,
  withIntervals: boolean,
) {
  return {
    title: "",
    content: "",
    collection_id: collectionIDs,
    url: [] as HGRecordUrl[],
    interval: withIntervals ? stacks.getInterval() : undefined,
    end_interval: withIntervals
      ? stacks.getEndInterval() || stacks.getInterval()
      : undefined,
  };
}

interface RecordNewProps {
  /** Which kind of record to create; mirrors the toolbar's active tab. */
  mode: RecordsMode;
}

export default function RecordNew({ mode }: RecordNewProps) {
  const collection = useCollection();
  const globalStacks = useGlobalStacks();
  const isOwnSpace = useIsOwnSpace();
  const [open, setOpen] = useState(false);

  // Someone else's page is read-only: the record would have to go into one of
  // their collections, which the API rejects.
  if (!isOwnSpace) return null;

  const collectionIDs = collection ? [collection.id] : [];

  return (
    <>
      <Button
        size="icon"
        variant="ghost"
        className="w-8 h-8"
        onClick={() => setOpen(true)}
      >
        <Plus />
      </Button>

      <RecordSheet
        record={getEmptyRecord(collectionIDs, globalStacks, mode === "time")}
        title="New record"
        open={open}
        onOpenChange={setOpen}
      />
    </>
  );
}
